<template>
  <div class="wrapper">
    <div style="margin: 0 auto 20px;position: relative;"  :style="{'max-width': maxWidth}" >
    <v-live
      :liveUrls="liveUrls"
      v-if="canPlay && liveUrls.length"
      @error="loadError"
      @load="loadPlayer"
      @playing="playing"
      @loadedmetadata="loadedmetadata"
      @seeked="handlSeeked"
      :ratio="ratio"></v-live>
      <div v-else>No live</div>
      <div v-show="playerStatus==='error'" class="cover">
        <div class="ended"><ct-icon name="info-empty"></ct-icon> The live broadcast is over</div>
      </div>
      <div v-show="playerStatus==='ready'" class="cover">
        <div class="ended"><ct-icon name="loading" data-animate="spin"></ct-icon>  Reconnecting...</div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@ca/api'
import VLive from '@ca/components/player/TcLive'
const maxHeight = Math.min(window.innerHeight - 220, 768)
const keepliveTime = 1000 * 60 // ms

export default {
  name: 'LiveVideo',
  components: {
    'v-live': VLive
  },
  computed: {
    liveUrls () {
      const { rtmp, flv, m3u8 } = this.$parent.live_play_url
      if (rtmp && flv && m3u8) {
        return [rtmp, flv, m3u8]
      } else {
        return []
      }
    },
    courseStatus () {
      return {
        loading: true || this.$parent.subclass.end_at,
        ended: true
      }
    },
    endAt () {
      const endAt = this.$parent.subclass.end_at
      return endAt
    },
    canPlay () {
      if (this.endAt) {
        const canPlay = this.judgeLiveVideoLimit(this.endAt)
        if (canPlay) {
          this.fetchLiveState()
          this.keeplive()
        }
        return canPlay
      } else {
        return true
      }
    }
  },
  data () {
    return {
      maxWidth: maxHeight / (3 / 4) + 'px',
      ratio: 4 / 3,
      playerStatus: null,
      player: null,
      playerInfo: null,
      // 推流状态 active：活跃， inactive：非活跃， forbid：禁播 other 其它
      pushStreamStatus: null,
      progressTimer: null
    }
  },
  methods: {
    loadError () {
      this.playerStatus = 'error'
    },
    // init player instance
    loadPlayer (player) {
      this.playerStatus = 'ready'
      this.player = player
    },
    loadedmetadata () {
      this.playerStatus = 'loadedmetadata'
    },
    // autoplay
    handlSeeked () {
      this.playerStatus = 'seeked'
      if (this.player.playing() === false) {
        this.play()
      }
    },
    playing () {
      this.playerStatus = 'playing'
    },
    play () {
      this.playerStatus = 'loadeddata'
      this.player.play()
    },
    reload () {
      console.log('reload player')
      this.player.load(this.player.options.src)
    },
    fetchLiveState () {
      if (this.endAt) {
        // confided end_at point ± 1min (keepliveTime)
        const liveEnded = Math.abs(+new Date() - this.endAt * 1000) < keepliveTime
        // TODO: 评分过的是否自动弹出
        if (liveEnded) {
          this.$parent.showPingfen()
        }
      }
      api.keepAlive({
        data: {
          class_id: this.$parent.liveId,
          subclass_id: this.$parent.subId
        }
      }).then(res => {
        if (res.data.data) {
          this.pushStreamStatus = res.data.data.live_state
          // 推流状态为active且当前未播放，重新播放
          if (this.pushStreamStatus === 'active' && this.player && this.playerStatus === 'error') {
            this.reload()
          }
        }
        // multi ip endter live room
        if (res.data && res.data.code === 90607) {
          this.player && this.player.destroy()
          this.$parent.msgDialog('Your account is log in Course System with another IP address. Please check your account and make sure others don’t know your password, otherwise reset your password for safety.')
        }
      })
    },
    keeplive () {
      this.progressTimer = window.setInterval(() => {
        this.fetchLiveState()
      }, keepliveTime)
    },
    judgeLiveVideoLimit (endAt) {
      const now = +new Date()
      let limitTime = new Date(endAt * 1000)
      limitTime.setHours(limitTime.getHours() + 2)
      if (now > limitTime) {
        this.$router.push({
          name: 'live-replay',
          params: {
            liveId: this.$parent.liveId,
            subId: this.$parent.subId
          }
        })
      }
      return now < limitTime
    }
  },
  mounted () {

  },
  destroyed () {
    window.clearInterval(this.progressTimer)
  }
}
</script>

<style lang="scss" scoped>
.badge {
  margin-right: 8px;
}
.video-card {
  margin-top: 20px;
  padding: 24px 24px 12px;
  .video-title {
    margin-bottom: 16px;
  }
  .labels {
    margin-bottom: 24px;
  }
}
.commonts-icon {
  margin: 0 -16px;
  text-align: right;
  padding-top: 12px;
}
.cover{
    position: absolute;
    background: #52545a;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 102;
    .ended{
      position: absolute;
      top: 50%;
      margin-top: -50px;
      width: 100%;
      color: #fff;
      text-align: center;
    }
}
</style>
